/**
 * Browser location for Near Me. Only ever called from a "Use my location" tap.
 * Coordinates are rounded to 2 dp (about 1.1 km) and never stored.
 */

import type { LatLon } from '@/types/nearMe';

export function roundCoord(value: number, places = 2): number {
  const factor = 10 ** places;
  return Math.round(value * factor) / factor;
}

export class LocationUnavailableError extends Error {}

export function requestBrowserLocation(
  geo: Geolocation | undefined = typeof navigator !== 'undefined' ? navigator.geolocation : undefined
): Promise<LatLon> {
  return new Promise((resolve, reject) => {
    if (!geo) {
      reject(new LocationUnavailableError('Location is not available in this browser. Search for a town or postcode instead.'));
      return;
    }
    geo.getCurrentPosition(
      (pos) => resolve({ lat: roundCoord(pos.coords.latitude), lon: roundCoord(pos.coords.longitude) }),
      (err) =>
        reject(
          new LocationUnavailableError(
            err.code === 1
              ? 'Location permission was denied. Search for a town or postcode instead.'
              : 'We could not get your location. Search for a town or postcode instead.'
          )
        ),
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
    );
  });
}
